<template>
  <vx-card class="mt-base" :title="activityTitle">
    <p class="mb-5">
      A visit to the vet can be a stressful time for a cat, or any animal for that matter. You must
      do everything you can to put your patient at ease as a vet. While many dogs are amiable and
      easy to handle as a result, cats often don’t enjoy being handled, especially by strangers.
    </p>
    <p class="mb-5">
      In the following video, Dr. Burstyn describes how to greet a cat-patient and how to go about
      picking them up and handling them. The focus here is not only on putting the cat or dog at
      ease but ensuring your own safety while you do it.
    </p>

    <responsive-youtube-wrapper :video="videos[1]" :image="videoTrigger1" />
    <p class="mb-5">In this video, you’ll have learned:</p>
    <ul class="default-list">
      <li>How to approach a cat and put it at ease</li>
      <li>How to pick up a cat</li>
      <li>How to restrain a cat with ‘The Squish’ and with a towel</li>
      <li>How to do the ‘Football Carry’</li>
      <li>How to do the ‘Shoulder Carry’</li>
    </ul>
    <p class="mb-5">
      Once you’re confident performing each of these techniques, it’s time to practise with a cat.
    </p>
    <p class="mb-5">
      <strong>Note:</strong> Only do this with an animal you feel safe with and that your
      parent/guardian approves of.
    </p>
    <p class="mb-5">Now, let’s take a look at how to pick up a dog:</p>

    <responsive-youtube-wrapper :video="videos[2]" :image="videoTrigger2" />
    <p class="mb-5">In this video, you’ll have learned:</p>
    <ul class="default-list">
      <li>How to lift a little dog</li>
      <li>How to lift a bigger dog</li>
      <li>How to lift a dog up from the floor (bend those knees!)</li>
      <li>How to pass a dog to another person</li>
    </ul>
    <p class="mb-5">
      Make sure you know how to perform each of the techniques described in both videos. Remember,
      you can re-watch the video as needed.
    </p>
    <p class="mb-5">
      Once you’re confident performing each of these techniques, it’s time to practice with a dog.
    </p>

    <p class="mb-5">
      <strong>Note:</strong> Only do this with an animal you feel safe with and that your
      parent/guardian approves of.
    </p>

    <div class="vx-row my-5">
      <div
        class="vx-col w-full mb-2"
        v-for="(answer, index2) in answers"
        :key="index2"
        v-if="isEditable"
      >
        <vs-radio
          vs-name="data-question1"
          v-model="data['question1']"
          class="checkbox_answer multiline"
          :vs-value="answer.val"
          >{{ answer.answer }}</vs-radio
        >
      </div>
      <div class="vx-col w-full mb-2" v-else>
        <vs-radio
          vs-name="data-question1"
          v-model="data['question1']"
          class="checkbox_answer multiline"
          :vs-value="answer.val"
          disabled="true"
          >{{ answer.answer }}</vs-radio
        >
      </div>
    </div>
    <p class="mb-5">In the comments below, type something you felt, learned, or that happened.</p>
    <textarea-block v-model="data.question2" :editable="isEditable" />

    <save-buttons :is-editable="isEditable" @save="save" />
  </vx-card>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/vet/activity_21.jpg'),
      videoTrigger2: require('@/assets/images/experiences/vet/activity_22.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/OAGfx7eB3gA',
        2: 'https://www.youtube.com/embed/cNw0SVvYUfU',
      },
      login_type: localStorage.getItem('login_type'),
      answers: [
        { val: 1, answer: 'I practised this with a cat' },
        { val: 2, answer: 'I practised this with a dog' },
        { val: 4, answer: 'I practised this with a cat and a dog' },
        {
          val: 3,
          answer:
            'I do not have access to a cat or dog that I feel safe with, but I watched and learned.',
        },
      ],
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
};
</script>

<style scoped>
.wrong {
  background: rgba(202, 20, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
  padding-top: 2px;
}
.correct {
  background: rgba(75, 202, 20, 0.24);
  border-bottom: 1px solid #f8f8f8;
}
.scale-header {
  background: #f5f5f5;
  padding-top: 5px;
  font-weight: 600;
}
</style>
